export const randomInteger = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const sumObjectArrayByKey = (items, prop, sumProp) => {
  if (items == null) {
    return 0;
  }
  return items.reduce(function (a, b) {
    if (b[prop] == null || b[prop][sumProp] == null) {
      return a;
    } else {
      return a + b[prop][sumProp];
    }
  }, 0);
};
